import { render, staticRenderFns } from "./BulkDeleteOverview.vue?vue&type=template&id=20cac8d4&scoped=true"
import script from "./BulkDeleteOverview.vue?vue&type=script&lang=js"
export * from "./BulkDeleteOverview.vue?vue&type=script&lang=js"
import style0 from "./BulkDeleteOverview.vue?vue&type=style&index=0&id=20cac8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cac8d4",
  null
  
)

export default component.exports